export interface WildlifeItem {
  id: string;
  image: string;
  isReverse?: boolean; // per alternare il layout
}

export const wildlifeItems: WildlifeItem[] = [
  {
    id: 'marsican_bear',
    image: '/curiosities/wildlife/marsican_bear.webp',
    isReverse: false
  },
  {
    id: 'pastore_abruzzese',
    image: '/curiosities/wildlife/pastore_abruzzese.webp',
    isReverse: true
  },
  {
    id: 'wolf',
    image: '/curiosities/wildlife/wolf.webp',
    isReverse: false
  },
  {
    id: 'dear',
    image: '/curiosities/wildlife/dear.webp',
    isReverse: true
  },
  {
    id: 'chamois',
    image: '/curiosities/wildlife/chamois.webp',
    isReverse: false
  },
  {
    id: 'fallow_deer',
    image: '/curiosities/wildlife/fallow_deer.webp',
    isReverse: true
  },
  {
    id: 'eagle',
    image: '/curiosities/wildlife/eagle.webp',
    isReverse: false
  },
  {
    id: 'sheep',
    image: '/curiosities/wildlife/sheep.webp',
    isReverse: true
  }
];